// src/components/auth/GoodbyePopup.jsx
// Combined Welcome & Goodbye Popup Component
import React, { useEffect, useState } from 'react';
import './GoodbyePopup.css';

const GoodbyePopup = ({ show, onClose, userName, isAdmin = false, type = 'goodbye' }) => {
  const [progress, setProgress] = useState(0);

  // Get time-based greeting for welcome
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 17) return 'Good Afternoon';
    return 'Good Evening';
  };

  useEffect(() => {
    if (show) {
      setProgress(0);
      
      // 2 seconds for both welcome and goodbye
      const duration = 2000;
      const increment = 100 / (duration / 50);
      
      const interval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) {
            clearInterval(interval);
            return 100;
          }
          return prev + increment;
        });
      }, 50);

      // Close after 2 seconds
      const timer = setTimeout(() => {
        onClose();
      }, duration);

      return () => {
        clearTimeout(timer);
        clearInterval(interval);
      };
    }
  }, [show, onClose, type]);

  if (!show) return null;

  const firstName = userName?.split(' ')[0] || 'Friend';

  // Welcome content
  if (type === 'welcome') {
    return (
      <div className="goodbye-overlay">
        <div className="goodbye-popup welcome-mode">
          {/* Sparkles */}
          <div className="goodbye-confetti">
            <span>✨</span>
            <span>🌟</span>
            <span>💫</span>
          </div>

          {/* Icon */}
          <div className="goodbye-icon">
            {isAdmin ? '👨‍💼' : '👋'}
          </div>

          {/* Greeting */}
          <p className="goodbye-greeting">{getGreeting()}</p>

          {/* Title */}
          <h2>Welcome Back, {firstName}!</h2>

          <p className="goodbye-subtitle">
            {isAdmin 
              ? "Ready to manage your empire?" 
              : "Great to see you again!"}
          </p>

          {/* Message */}
          <div className="goodbye-message">
            {isAdmin ? (
              <div className="admin-badge">
                <i className='uil uil-shield-check'></i>
                <span>Admin Access</span>
              </div>
            ) : (
              <p>Your dashboard is ready and waiting 🚀</p>
            )}
          </div>

          {/* Loader */}
          <div className="goodbye-loader">
            <div 
              className="goodbye-loader-fill welcome-loader" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>

          <p className="goodbye-redirect">
            {isAdmin ? 'Loading admin dashboard...' : 'Loading your dashboard...'}
          </p>
        </div>
      </div>
    );
  }

  // Goodbye content (default)
  return (
    <div className="goodbye-overlay">
      <div className="goodbye-popup">
        {/* Confetti */}
        <div className="goodbye-confetti">
          <span>🎉</span>
          <span>✨</span>
          <span>💫</span>
        </div>
        
        {/* Icon */}
        <div className="goodbye-icon">👋</div>
        
        {/* Title */}
        <h2>Goodbye, {firstName}!</h2>
        
        <p className="goodbye-subtitle">You've been successfully logged out</p>
        
        {/* Message */}
        <div className="goodbye-message">
          <p>Thank you for choosing <strong>SpinoSoftBits</strong></p>
          <p>We hope to see you again soon! 💜</p>
        </div>

        {/* Stats */}
        <div className="goodbye-stats">
          <div className="goodbye-stat">
            <i className='uil uil-check-circle'></i>
            <span>Session secured</span>
          </div>
          <div className="goodbye-stat">
            <i className='uil uil-shield-check'></i>
            <span>Data protected</span>
          </div>
        </div>
        
        {/* Loader */}
        <div className="goodbye-loader">
          <div 
            className="goodbye-loader-fill" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        
        <p className="goodbye-redirect">Redirecting to home page...</p>
      </div>
    </div>
  );
};

export default GoodbyePopup;